module.exports = __webpack_public_path__ + "img/google tv 86.d8054ae5.jpg";